import { ActionPointInfo, Controller, IActionPointInfo, IDynamicLoader, Loader, Toolbar, Menu } from '@tencent/workbench';
import { IInsertCommentFeature } from './insert-comment-interface';
import { MENU_CONFIGS, TOOLBAR_ITEMS, config } from './config';
import { FIXED_KEYS_DOUBLE } from '@src/framework/workbench/schema/constant';
import { i18n } from '@src/slide/application/service/edit-extension/edit-extension-export';
import { ActionType } from '@editor/src/js/constants/common-action-type';

@Controller({
    toolbarItems: TOOLBAR_ITEMS,
    menuItems: MENU_CONFIGS,
})
export class InsertCommentController {
    public constructor(@Loader(IInsertCommentFeature) private loader: IDynamicLoader<IInsertCommentFeature>) {
    }

    private get feature() {
        return this.loader.instance!;
    }

    @Toolbar(config.id, 'onClick')
    @Menu(config.id, 'onClick')
    public handleCommentInsertClick() {
        this.feature.handleInsertComment();
    }

    @Toolbar(config.id, 'text')
    public handleCommentText(@ActionPointInfo() info: IActionPointInfo) {
        if (info.path.includes(FIXED_KEYS_DOUBLE.TOOLBAR_INSERT)) {
            return i18n.t('批注');
        }
        return config.content;
    }

    @Toolbar(config.id, 'tooltip')
    public handleCommentTooltip(@ActionPointInfo() info: IActionPointInfo) {
        if (info.path.includes(FIXED_KEYS_DOUBLE.TOOLBAR_INSERT)) {
            return i18n.t('批注');
        }
        return config.content;
    }

    @Toolbar(config.id, 'shouldHide')
    @Menu(config.id, 'shouldHide')
    public shouldHide() {
        return this.feature.shouldHide();
    }

    @Toolbar(config.id, 'shouldDisabled')
    @Menu(config.id, 'shouldDisabled')
    public shouldDisable(): boolean {
        return this.feature.shouldDisabled(ActionType.INSERT_COMMENT);
    }
}
